module.exports = __webpack_public_path__ + "img/xyf.124774ed.png";